(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curated-products-monalisa"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 768) return; // Only mobile

  var sliderEl = document.querySelector('.keen-slider.mb-slider');
  if (!sliderEl || typeof KeenSlider === 'undefined') return;

  var dotsContainer = document.querySelector('.keen-dots');

  var slider = new KeenSlider(sliderEl, {
    loop: false,
    slides: {
      perView: 1,
      spacing: 16
    },
    created(s) {
      createDots(s);
    },
    slideChanged(s) {
      updateDots(s);
    }
  });

  function createDots(s) {
    dotsContainer.innerHTML = '';
    Array.from({ length: s.track.details.slides.length }).forEach((_, idx) => {
      const dot = document.createElement("button");
      dot.classList.add("dot");
      dot.addEventListener("click", () => s.moveToIdx(idx));
      dotsContainer.appendChild(dot);
    });
    updateDots(s);
  }

  function updateDots(s) {
    const active = s.track.details.rel;
    [...dotsContainer.children].forEach((dot, idx) => {
      dot.classList.toggle("active", idx === active);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
